const shift = 13;
export const encrypt = (text) => text.split('').map(char => String.fromCharCode(char.charCodeAt(0) + shift)).join('');
export const decrypt = (text) => text.split('').map(char => String.fromCharCode(char.charCodeAt(0) - shift)).join('');
